const menus = [
  {
    name: "index",
    title: "主页",
    path: "/",
  },
  {
    name: "aboutUs",
    title: "关于我们",
    path: "/aboutUs",
    children: [
      {
        name: "companyIntroduction",
        title: "公司介绍",
        path: "/companyIntroduction",
      },
      {
        name: "serviceAdvantages",
        title: "业务优势介绍",
        path: "/serviceAdvantages",
      },
      {
        name: "developmentHistory",
        title: "发展历程",
        path: "/developmentHistory",
      },
    ],
  },
  {
    name: "productIntroduction",
    title: "疾病与治疗",
    path: "/productIntroduction",
    children: [
      {
        name: "relatedDiseases",
        title: "相关疾病",
        path: "/relatedDiseases",
      },
      {
        name: "productPresentation",
        title: "产品介绍",
        path: "/productPresentation",
      },
    ],
  },
  {
    name: "newsInformation",
    title: "新闻资讯",
    path: "/newsInformation",
  },
  {
    name: "personnelRecruitment",
    title: "人才招聘",
    path: "/personnelRecruitment",
  },
  {
    name: "contactUs",
    title: "联系我们",
    path: "",
  },
  // {
  //   name: "newsDetail",
  //   title: "新闻详情",
  //   path: "/newsDetail",
  //   type: "child",
  // },
  // {
  //   name: "productDetail",
  //   title: "相关疾病或产品详情",
  //   path: "/productDetail",
  //   type: "child",
  // },
];

export default menus;
